<template lang="pug">
    .display-value( :class="{'inline': $props.inline}")
        label.label {{$props.label}}
        span.value {{$props.value}}
</template>

<script>
    export default {
        name: 'display-value',
        props: {
            'value': {type: [String, Number, Date], default: ''},
            'label': {type: String, default: ''},
            'inline': {type: Boolean, default: false},
        },
        data() {
            return {}
        },
        created() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
<style scoped lang="sass">
    .display-value
        position: relative
        width: 100%
        margin: 0 0 10px 0
        padding: 0 0 5px 0
        display: flex
        flex-direction: column
        flex-wrap: wrap
        &:after
            content: ''
            height: 1px
            width: 100%
            position: absolute
            bottom: 0
            left: 0
            right: 0
            background: rgba(0, 0, 0, 0.38)
        .label
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            margin: 0 5px 0 0
        .value
    .display-value.inline
        flex-direction: row
</style>


// WEBPACK FOOTER //
// DisplayValue.vue?325d5205